import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class ActionTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "modelColumn", title: "Model" },
        { name: "pttimeoutColumn", title: "ptzmove + pan/tilt + timeout" },
        { name: "zftimeoutColumn", title: "ptzmove + zoom/focus + timeout" },
        { name: "ptColumn", title: "ptzmove + pan/tilt" },
        { name: "zfColumn", title: "ptzmove + zoom/focus" }
      ],
      rows: [
        { 
          modelColumn: 'e.g. IN-8415',
          pttimeoutColumn: 'supported',
          zftimeoutColumn: 'not supported',
          ptColumn: 'supported',
          zfColumn: 'not supported'
        },
        {
          modelColumn: 'e.g. IN-9420',
          pttimeoutColumn: 'supported',
          zftimeoutColumn: 'supported',
          ptColumn: 'move to hard stop',
          zfColumn: 'supported'
        },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

ActionTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ActionTable)